function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgCamerasEDrones = function SvgCamerasEDrones(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.984 9.844c-.814-.888-1.285-1.882-1.086-3.09.158-.962.676-1.716 1.456-2.296 1.42-1.057 3.622-1.189 5.18.94.066-.192.112-.377.191-.546.164-.35.329-.7.527-1.031a.624.624 0 01.603-.32c.204.016.362.106.45.294a.536.536 0 01-.069.588c-.324.416-.541.879-.651 1.394-.4 1.868.987 4.256 3.729 3.904 1.372-.176 2.348-.907 2.763-2.24.694-2.23-.985-4.38-3.346-4.316-.11.003-.218.016-.326.015a.536.536 0 01-.546-.46c-.047-.274.074-.493.359-.585.47-.153.952-.092 1.426-.02 2.051.314 3.43 2.049 3.648 3.856.176 1.453-.269 2.69-1.345 3.7-.02.018-.039.04-.073.074 1.733.178 2.66 1.114 2.805 2.834.062-.028.134-.056.202-.09.858-.423 1.715-.848 2.574-1.27.804-.396 1.543.052 1.544.938v7.518c0 .85-.752 1.308-1.524.93-.866-.424-1.73-.853-2.593-1.28l-.212-.098c-.023.206-.034.395-.067.58a2.703 2.703 0 01-2.649 2.226c-4.082.009-8.164.01-12.247 0-1.476-.005-2.682-1.19-2.694-2.652-.02-2.305-.015-4.61-.001-6.915.007-1.152.705-2.1 1.796-2.511l.178-.072h-.002zm6.838 11.043c2 0 4.002.002 6.003 0 1.012 0 1.7-.656 1.703-1.648.009-2.248.009-4.496 0-6.742-.003-.99-.698-1.653-1.702-1.654H3.842c-1.03 0-1.71.668-1.711 1.684-.002 2.226 0 4.452 0 6.677 0 .122 0 .246.022.365.15.797.793 1.316 1.643 1.317 2.009.004 4.017.001 6.025.001h.001zM3.002 7.29c0 1.388 1.068 2.43 2.486 2.425C6.896 9.709 7.95 8.68 7.965 7.297 7.98 5.924 6.9 4.863 5.486 4.861 4.068 4.859 3.001 5.9 3.002 7.289zm18.858 4.935c-.048.018-.076.027-.1.039-.994.49-1.987.983-2.983 1.468-.127.06-.134.145-.134.257.001 1.256.003 2.512-.002 3.767 0 .135.043.202.164.26.82.399 1.637.806 2.456 1.209l.6.293v-7.293h-.001zM8.89 8.51L8.16 9.719h1.67l-.94-1.21h-.002z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.01 13c1.457 0 2.915 0 4.372.002.462 0 .732.33.572.687a.493.493 0 01-.439.297 2.675 2.675 0 01-.25.014H5.704c-.476 0-.73-.2-.7-.541.024-.282.24-.455.589-.457.781-.004 1.564-.001 2.346-.001h2.072z",
    fill: props.color
  }));
};
SvgCamerasEDrones.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgCamerasEDrones.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgCamerasEDrones;